import { useOrganization, useUser } from "@clerk/react-router";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";

export function SentryUser() {
  const { user, isLoaded: userLoaded } = useUser();
  const { organization, membership, isLoaded: orgLoaded } = useOrganization();

  useEffect(() => {
    if (userLoaded && orgLoaded) {
      if (user) {
        const userContext = {
          id: user.id,
          email: user.primaryEmailAddress?.emailAddress,
          username: user.username ?? undefined,
        };

        if (organization) {
          Sentry.setUser({
            ...userContext,
            currentOrgId: organization.id,
            currentOrgName: organization.name,
            currentOrgRole: membership?.role,
          });
        } else {
          Sentry.setUser(userContext);
        }
      } else {
        Sentry.setUser(null);
      }
    }
  }, [userLoaded, orgLoaded, user, organization, membership]);

  return null;
}
